import WaviotApi from '../apis/ReportWaviotApi.js';

export default {
    namespaced: true,
    state: {
        loading: false,
        logs: [],
        recipient: [],
        headers:[],
        recipientList: [],
        showDialogAdd: false,
        showDialogEdit: false,
        snackBarShow: false,
        snackBarMsg: ''
    },
    getters: {
        get_snack_bar(state){
            return state.snackBarShow
        },
        get_snack_bar_msg(state){
            return state.snackBarMsg
        },
        get_recipient(state) {
            return state.recipient
        },
        get_recipientList(state) {
            return state.recipientList
        },
        get_headers(state) {
            return state.headers
        },
        get_logs(state) {
            return state.logs
        },
        get_loading(state) {
            return Boolean(state.loading)
        },
        get_showDialogAdd(state) {
            return Boolean(state.showDialogAdd)
        },
        get_showDialogEdit(state) {
            return Boolean(state.showDialogEdit)
        }

    },
    mutations: {
        set_snack_bar(state, payload){
            state.snackBarShow = payload
        },
        set_snack_bar_msg(state, msg){
            state.snackBarMsg = msg
        },
        set_recipient(state, payload) {
            state.recipient = payload
        },
        set_recipientList(state, payload) {
            state.recipientList = payload
        },
        set_headers(state, payload) {
            state.headers = payload
        },
        set_logs(state, payload) {
            state.logs = payload
        },
        set_loading(state, payload) {
            state.loading = Boolean(payload)
        },
        set_showDialogAdd(state, payload) {
            state.showDialogAdd = Boolean(payload)
        },
        set_showDialogEdit(state, payload) {
            state.showDialogEdit = Boolean(payload)
        }
    },
    actions: {
        add_recipient({commit, state},payload) {
            WaviotApi.add(payload)
                .then(res => {
                    if (!res.data.success) {
                        this.snackMsg = res.data.message
                        this.snackbar = true
                        this.fetch_recipientList()
                        commit('set_showDialogAdd', false)
                    } else {
                        this.get_recipient = {
                            name: '',
                            active: false,
                            props: {}
                        }
                        this.snackMsg = res.data.message
                        this.snackbar = true

                    }
                })
        },
        async fetch_recipientList({commit}) {
            //commit('set_loading', true)
            await WaviotApi.get_recipients()
                .then(r => {
                    commit('set_recipientList',r.data.data)
                    commit('set_headers',r.data.headers)
                    // r.data.data.forEach((ele, inx) => {
                    //     ele.active = Boolean(ele.active)
                    //     recipients[inx].waviot_type = ele.props.waviot_type
                    //     recipients[inx].email = ele.props.email
                    //     recipients[inx].num_day_send = ele.props.num_day_send
                    //     recipients[inx].num_hour_send = ele.props.num_hour_send
                    //     recipients[inx].value_date = ele.props.value_date
                    // })

                })
                .finally(()=>{
                   // commit('set_loading', false)
                })
        },
        fetch_recipient({commit, state}, id) {
            commit('set_loading', true);
            WaviotApi.get_recipient(id).then(res => {
                let recipient = {
                    id: res.data.id,
                    name: res.data.name,
                    active: res.data.active,
                    props: res.data.props
                }
                commit('set_recipient', recipient)
                commit('set_loading', false)
                commit('set_showDialogEdit', true)
            })
        },
        fetch_logs({commit, state}) {
            commit('set_loading', true)
            WaviotApi.get_recipients().then(r => {
                commit('set_logs', r.data)
                commit('set_loading', false)
            })
        },
    },

}

